import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
  Button,
  Container,
  Spinner,
  Accordion,
} from '@themesberg/react-bootstrap';
import CustomErrorView from '../../components/CustomErrorView';
import { useSelector, useDispatch } from 'react-redux';
import {
  clearIndividualCollector,
  getCollectorById,
} from '../../redux/actions/collector';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import { DateFormatter2 } from '../../helpers/DateFormatter2';
import ColorComponent from '../../components/ColorComponent';
import CollectorDetailHeader from '../../components/CollectorDetailHeader';
import CollectorAssignedCustomer from './CollectorAssignedCustomer';

const Labels = (key, value) => {
  return (
    <div className='d-flex mb-3 '>
      <h6>{key}: </h6>
      <span>&nbsp;</span>
      <h6>{value ?? 'N/A'}</h6>
    </div>
  );
};

function CustomerDetail({ match, history }) {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const individualData = useSelector(
    (state) => state.collector.individualCollector
  );

  // const {id,name,email,mobileNumber,username,totalAssignedCustomer,lastBatchDate} = individualData

  const handleSuccess = () => {
    setIsLoading(false);
  };
  const handleFailure = () => {
    setIsLoading(false);
    setShowErrPage(true);
  };
  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      dispatch(getCollectorById(someId, handleSuccess, handleFailure));
    }
    return () => {
      dispatch(clearIndividualCollector());
    };
  }, []);

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <div>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <div className='bg-soft'>
            {/* <Container> */}
              <CollectorDetailHeader collectorData={individualData} />
              <CollectorAssignedCustomer />

              {/* <Accordion.Item eventKey='0'>
                  <Accordion.Header>Collector Details</Accordion.Header>
                  <Accordion.Body>
                    <Row className=' d-flex' style={{ alignItems: 'center' }}>
                      <Col md={12} lg={6}>
                        <h5>{individualData.name}</h5>
                      </Col>
                      <Col
                        md={12}
                        lg={6}
                        className='d-flex'
                        style={{ justifyContent: 'flex-end' }}
                      >
                        <Button
                          variant='primary'
                          onClick={() => {
                            history.push(
                              `/collectors/edit/${individualData.id}`
                            );
                          }}
                          disabled={isSubmitting}
                        >
                          Edit Collector
                        </Button>
                      </Col>
                      <div className='d-flex mb-3 '>
                        <ColorComponent value={individualData.isActive} />
                      </div>
                      {console.log(individualData.isActive, 'this')}

                      {Labels('Id', individualData.id)}
                      {Labels('Username', individualData.username)}
                      {Labels('Email', individualData.email)}
                      {Labels('Phone Number', individualData.mobileNumber)}
                      {Labels(
                        'Total Customers',
                        individualData.totalAssignedCustomer
                      )}
                      {Labels(
                        'Last Batch Update',
                        DateFormatter2(individualData.lastBatchDate)
                      )}
                    </Row>
                  </Accordion.Body>
                </Accordion.Item> */}
              {/* <Accordion.Item eventKey="1">
                  <Accordion.Header>View Transactions Batches(TODO)</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex justify-content-between">
                      <h5>Last 5 Transactions Batches</h5>

                      <Button
                        variant="primary"
                        onClick={() => {
                          // history.push(
                          //   `/customers/transaction/detail/${individualCustomer.customerId}`
                          // );
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item> */}
            {/* </Container> */}
          </div>
        )}
      </div>
    );
  }
}

export default CustomerDetail;
